import { createContext } from 'react';

export interface TableContextType {
  bleed: boolean;
  dense: boolean;
  flush: boolean;
  grid: boolean;
  hasRowActions: boolean;
  loading: boolean;
  selectable: boolean;
  shouldReduceMotion: boolean;
  striped: boolean;
}

export const TableContext = createContext<TableContextType>({
  bleed: false,
  dense: false,
  flush: false,
  grid: false,
  hasRowActions: false,
  loading: false,
  selectable: false,
  shouldReduceMotion: false,
  striped: false
});
